import React, { useEffect, useState } from 'react';
import { HourglassIcon } from 'lucide-react';
const TOTAL_SECONDS = 23 * 3600 + 57 * 60 + 45;
function useCountdown(initialSeconds: number) {
  const [seconds, setSeconds] = useState(initialSeconds);
  useEffect(() => {
    const id = setInterval(() => setSeconds(s => s > 0 ? s - 1 : 0), 1000);
    return () => clearInterval(id);
  }, []);
  return {
    hh: Math.floor(seconds / 3600),
    mm: Math.floor(seconds % 3600 / 60),
    ss: seconds % 60
  };
}
function Unit({
  value,
  label
}: {
  value: number;
  label: string;
}) {
  return <span className="inline-flex items-baseline gap-1.5" data-id="element-95" data-mp="5d38k8wi9ksx">
      <span className="font-display text-2xl font-black tabular-nums tracking-wide sm:text-3xl" style={{
      fontFamily: 'Montserrat, sans-serif',
      fontSize: "20px"
    }} data-id="element-96" data-mp="5eo1xv732xp7">
        {String(value).padStart(2, '0')}
      </span>
      <span className="text-[10px] font-bold uppercase tracking-widest sm:text-xs" data-id="element-97" data-mp="3sjvszlgq8wn8">{label}</span>
    </span>;
}
export function OfferBar() {
  const {
    hh,
    mm,
    ss
  } = useCountdown(TOTAL_SECONDS);
  return <div role="region" aria-label="Launch offer countdown" className="fixed inset-x-0 top-0 z-50 bg-grape text-white shadow-[0_6px_20px_-10px_rgba(46,21,18,0.6)]" data-id="element-98" data-mp="r169ttew1nbv">
      <div className="mx-auto flex max-w-5xl items-center justify-between gap-4 px-4 py-3 sm:px-6" style={{
      paddingTop: "5px",
      paddingBottom: "6px",
      width: "374px",
      height: "40px"
    }} data-id="element-99" data-mp="10vf00agg546v">
        <p className="flex items-center gap-2.5 text-[13px] font-extrabold uppercase leading-tight tracking-[0.18em] sm:text-base sm:tracking-[0.22em]" data-id="element-100" data-mp="89djy7v48i8d">
          <HourglassIcon className="h-5 w-5 shrink-0" aria-hidden="true" style={{
          width: "17px",
          height: "19px"
        }} data-id="element-101" data-mp="hz5ej237tbcu" />
          <span style={{
          fontSize: "8px"
        }} data-id="element-102" data-mp="d759iv8afs9e">Launch offer ends in:</span>
        </p>

        <p className="flex shrink-0 items-baseline gap-1.5 sm:gap-2.5" data-id="element-103" data-mp="3lmfh2iuy5pok">
          <Unit value={hh} label="Hrs" data-id="element-104" data-mp="3gp5kmj954dr8" />
          <span className="text-xl font-black opacity-70" data-id="element-105" data-mp="3go44w1h6j336">:</span>
          <Unit value={mm} label="Min" data-id="element-106" data-mp="1kmaj6r72s4mw" />
          <span className="text-xl font-black opacity-70" data-id="element-107" data-mp="1kl8yrw4665si">:</span>
          <Unit value={ss} label="Sec" data-id="element-108" data-mp="1pjk885qjyea7" />
        </p>
      </div>
    </div>;
}